/* @flow */
import React, {PureComponent} from 'react';
import {AD_ID} from '../../../constants/ads';

type Props = {
    updateAdSense: () => void
};

export default class AdSense extends PureComponent<Props> {
    componentDidMount() {
        this.props.updateAdSense();
    }

    render() {
        return <div id={AD_ID} />;
    }
}
